(function (Drupal, $) {
  Drupal.behaviors.scrollTop = {
    attach: function (context) {
      "use strict";
      //scroll to top
      function adjustScrollToTop() {
        var top = $(window).scrollTop();
        var pos = top + $(window).outerHeight();
        var footerPos = $("footer").offset().top;
        var footerPosMob = footerPos + $(".footer-left").outerHeight();

        top == 0
          ? $(".page-top-scroll__wrapper").addClass("top")
          : $(".page-top-scroll__wrapper").removeClass("top");

        if (footerPos - pos < 10) { //at the bottom
          if (!window.matchMedia("(min-width: 1200px)").matches) { //On mobile
            if (footerPosMob - pos > -38) {
              $(".page-top-scroll__wrapper").css(
                "margin-top",
                $(".footer-left").outerHeight() - (footerPosMob - pos) + "px"
              );
            } else {
              //default if scrolling too fast
              $(".page-top-scroll__wrapper").css(
                "margin-top",
                $(".footer-left").outerHeight() + 38 + "px"
              );
            }
          } else { //On desktop
            $(".page-top-scroll__wrapper").addClass("bottom");
          }
        } else {
          $(".page-top-scroll__wrapper").removeClass("bottom");
          $(".page-top-scroll__wrapper").css("margin-top", 0);
        }
      }
      $(window).on("scroll", function () {
        adjustScrollToTop();
      });

      context.querySelectorAll(".page-top-scroll__wrapper>button").forEach(function (button) {
        button.addEventListener("click", function () {
          window.scrollTo({
            top: 0,
            behavior: "smooth" // Optional for smooth scrolling
          });
          button.blur();
        });
      });

    },
  };
})(Drupal, jQuery);
